import axios from "axios";
// =======  preparing to the deplyment  ========
const URL = `https://viva3dfilms.com`
// =============================================
const customInstance = axios.create({
    baseURL: URL,
    headers: { Accept: "application/json" },
});

export default customInstance;